import React from 'react';
import info from "../../images/info.svg";

class StoreMainItem extends React.Component {


    render() {

        let mainItemClass = 'c-locations__location'

        if (this.props.openId === this.props.id) {
            mainItemClass += ' js-locationActive'
        }

        return (


            <div className={mainItemClass} id={this.props.id}>
                <div className="c-locations__location__image u-bg-cover-center"
                     style={{backgroundImage: "url(" + this.props.headerImage + ")"}}/>
                <button className="c-locations__location__close js-closeLocation"
                        onClick={() => this.props.closeMainItem()}>
                    <i className="icon-cross"/>
                </button>
                <div className="c-locations__location__body">
                    <address className="c-locations__location__intro">
                        <h3><a href={this.props.url}>{this.props.companyName}</a></h3>
                        <span><a
                            href={this.props.url}>{this.props.street} {this.props.houseNumber}{this.props.houseNumberAdd}, {this.props.zipCode} {this.props.city}</a></span>
                    </address>
                    {!!this.props.reviewCount &&
                        <div className="c-review-stars">
                            <div className="c-review-stars__wrap">
                                <span>{this.props.averageScore}</span>
                                <div className="c-review-stars__stars"
                                     dangerouslySetInnerHTML={{__html: this.stars(this.props.averageScore)}}/>
                            </div>
                            <a href={this.props.reviewLink}>{this.props.reviewCount} beoordelingen</a>
                        </div>
                    }
                    <a href={this.props.url} className="c-locations__location__time">
                        {this.props.closedTime ? (
                            <span>Vandaag geopend tot {this.props.closedTime}</span>
                        ) : (
                            <span>Vandaag gesloten</span>
                        )}
                        <i className="icon-arrow-right"/>
                    </a>
                    <div className="c-locations__location__contact">
                        <a href={'tel:' + this.props.phoneNumber}>
                            <div className="btn btn--square btn--square-small btn--outline-orange"><i
                                className="icon-phone"/></div>
                            <span>{this.props.phoneNumber}</span>
                        </a>
                        <a href={'mailto:' + this.props.email}>
                            <div className="btn btn--square btn--square-small btn--outline-orange"><i
                                className="icon-email"/></div>
                            <span>{this.props.email}</span>
                        </a>
                    </div>
                    {!!this.props.specialism &&
                        <div className="c-locations__location__categories">
                            {Object.values(this.props.specialism).map((data) => {
                                    if (!!data) {
                                        return (
                                            <div className="btn btn--pill btn--pill--gray"><span>{data}</span></div>
                                        )
                                    }
                                }
                            )}
                        </div>
                    }
                    {!!this.props.noAppointmentCheck &&
                        <div className="c-locations__location__time">
                            <img src={info} className="info-icon-image"/>
                            <span>Het is niet mogelijk om een afspraak te maken bij deze vestiging</span>
                        </div>
                    }
                    <div className="c-locations__location__cta">
                        {!this.props.noAppointmentCheck &&
                            <a href={this.props.appointmentLink} className="btn btn--icon btn--orange">
                                <span>Afspraak maken</span>
                                <i className="icon-arrow-right-circle"/>
                            </a>
                        }
                        <a href={this.props.url} className="btn btn--icon btn--gray">
                            <span>Bekijk vestiging</span>
                            <i className="icon-arrow-right-circle"/>
                        </a>
                    </div>
                </div>
            </div>

        )
    }

    stars = (score) => {
        const starCount = Math.round(score / 2)
        let html = ""
        let i
        for (i = 1; i <= starCount; i++) {
            html += '<i class="icon-star"></i>'
        }
        if (i < 6) {
            while (i < 6) {
                html += '<i class="icon-star icon-star--gray"></i>'
                i++
            }
        }
        return html
    }

}

export default StoreMainItem
